import { chain, find, head, pipe, prop, propEq, replace } from 'ramda';
import { MediaManagerSDKPublicMediaFolder } from '../../hoc/withPublicMedia/withPublicMedia.types';

export const readCookie = (name) => {
  const processedName = replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1', name);

  const regex = new RegExp(`(?:^|;)\\s?${processedName}=(.*?)(?:;|$)`, 'i');
  const match = document.cookie.match(regex);

  return match && unescape(match[1]);
};

export const getSubFoldersOfFirstItem = pipe<
  MediaManagerSDKPublicMediaFolder[],
  MediaManagerSDKPublicMediaFolder,
  MediaManagerSDKPublicMediaFolder[]
>(head, prop('subFolders'));

export const getIdOfFirstItem = pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder, string>(
  head,
  prop('id'),
);

export const findCategoryBySubCategoryId = (subCategoryId, categories) => () =>
  pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder>(
    chain(prop('subFolders')),
    find(pipe(prop('subFolders'), head, propEq('id', subCategoryId))),
  )(categories);

export const getCategoryProperty = (propName, childCategoryId, categories) =>
  pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder, string>(
    findCategoryBySubCategoryId(childCategoryId, categories),
    prop(propName),
  )(categories);
